import { Skeleton } from './Skeleton';

/** Loading-state skeleton for a sticky right-aligned "Actions" table cell.
 *
 * Extracted verbatim from the store-management list tables
 * (MarketRegularizationReasonsPage / StoreCategoriesPage), where this exact
 * `<td>` markup with two square skeleton buttons was duplicated inside the
 * loading branch. Renders a single table cell, so it must be placed inside a
 * `<tr>`. No props — markup is identical in both callers. */
export function ActionsSkeletonCell() {
  return (
    <td className="sticky right-0 z-10 whitespace-nowrap bg-white px-6 py-4 shadow-[-4px_0_6px_-4px_rgba(0,0,0,0.1)]">
      <div className="flex items-center justify-center gap-2">
        <Skeleton className="h-8 w-8 rounded-lg" />
        <Skeleton className="h-8 w-8 rounded-lg" />
      </div>
    </td>
  );
}
